import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";


function ProductSubmenu(props){

    const [active,setActive] = useState(false);
    const wrapperRef = useRef(null);

    const closeChildHandler = () => {
        setActive(false);
        props.onClose();
    }

    /**
     * Hook that alerts clicks outside of the passed ref
     */
    function useOutsideAlerter(ref) {
        useEffect(() => {
            let allowedClassNames = ["checkbox-label","bp3-menu","bp3-text-overflow-ellipsis bp3-fill"];

            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target) && event.target.parentElement != null) {

                    if(allowedClassNames.indexOf(event.target.className) === -1 && allowedClassNames.indexOf(event.target.parentElement.className) === -1) {
                        setActive(false);
                   }

                }
            }

            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);

    }

    useOutsideAlerter(wrapperRef);

    const toggleSubmenu = () => {
        // On mobile, drill into a dedicated submenu view instead of the
        // inline dropdown card (desktop behaviour is unchanged).
        if (typeof props.onMobileExpand === "function" &&
            typeof window !== "undefined" &&
            window.matchMedia("(max-width: 767px)").matches) {
            props.onMobileExpand();
            return;
        }
        setActive(prevState => !prevState);
    };

    return (
        <div ref={wrapperRef} className={"product-menu-item " + (active ? "active" : "")} id={props.id}>
            {props.href ? (
                <div className="product-submenu-trigger">
                    <Link to={props.href} className="product-submenu-link" onClick={closeChildHandler}>{props.name}</Link>
                    <button
                        type="button"
                        className={"product-submenu-arrow-btn" + (active ? " active" : "")}
                        onClick={toggleSubmenu}
                        aria-label="Rozwiń menu"
                    />
                </div>
            ) : (
                <div onClick={toggleSubmenu}>{props.name}</div>
            )}
            <div className="product-sub-menu">
                {React.cloneElement(props.children, { onClose: closeChildHandler })}
            </div>
        </div>
    );
}

export default ProductSubmenu;
